import { useQuery, QueryHookOptions } from '@apollo/client'

import { GET_PROMO_BANNERS } from '../apollo/promo-banner.graphql'
import { useRestaurant } from '@local/do-secundo-restaurant-provider'

import { PromoBanner } from '../@types'

type PromoBannerInput = {
  input: {
    restaurantGuid: string
  }
}

type PromoBannerResponse = {
  promoBanners: {
    banners: PromoBanner[]
  }
}

type GetPromoBannerQueryOptions = QueryHookOptions<
  PromoBannerResponse,
  PromoBannerInput
>

export const useGetPromoBanners = (
  queryOptions: GetPromoBannerQueryOptions = {}
) => {
  const { restaurantGuid } = useRestaurant()

  return useQuery<PromoBannerResponse, PromoBannerInput>(GET_PROMO_BANNERS, {
    notifyOnNetworkStatusChange: true,
    variables: {
      input: {
        restaurantGuid
      }
    },
    ...queryOptions
  })
}
